var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-100 d-none d-md-block hidden" }, [
    _c("div", { staticClass: "h-100 font-weight-bold pr-0 pl-0 ml-0" }, [
      _c(
        "div",
        {
          staticClass: "dropdown border-left d-none d-md-block h-100",
          attrs: { id: "recent-tasks-nav-container" },
        },
        [
          !_vm.isUserRegistered
            ? _c(
                "a",
                {
                  staticClass:
                    "bg-white pr-3 pl-3 dropdown-toggle d-flex flex-column h-100 align-items-center justify-content-center fg-normal fg-main-hover fg-main-dropdown-show position-relative font-weight-bold",
                  attrs: {
                    href: "#",
                    role: "button",
                    "data-toggle": "tooltip",
                    "data-original-title": _vm.bubbleSpeechText,
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "28",
                        height: "30",
                        viewBox: "0 0 28 30",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M25.0943 13.7864V5.45455C25.0943 4.73123 24.8069 4.03754 24.2955 3.52607C23.784 3.01461 23.0903 2.72727 22.367 2.72727H16.667C16.0943 1.14545 14.5943 0 12.8216 0C11.0488 0 9.54882 1.14545 8.9761 2.72727H3.2761C1.7761 2.72727 0.548828 3.95455 0.548828 5.45455V24.5455C0.548828 25.2688 0.836165 25.9625 1.34763 26.4739C1.85909 26.9854 2.55278 27.2727 3.2761 27.2727H11.6079C13.3261 28.9636 15.6715 30 18.2761 30C23.5534 30 27.8215 25.7318 27.8215 20.4545C27.8215 17.85 26.7852 15.5045 25.0943 13.7864ZM12.8216 2.72727C13.5715 2.72727 14.1852 3.34091 14.1852 4.09091C14.1852 4.84091 13.5715 5.45455 12.8216 5.45455C12.0716 5.45455 11.4579 4.84091 11.4579 4.09091C11.4579 3.34091 12.0716 2.72727 12.8216 2.72727ZM3.2761 24.5455V5.45455H6.00337V8.18182H19.6397V5.45455H22.367V11.8364C20.5883 10.9913 18.5916 10.7174 16.6511 11.0524C14.7105 11.3873 12.9212 12.3147 11.5287 13.7072C10.1362 15.0996 9.20888 16.889 8.87392 18.8295C8.53896 20.7701 8.81282 22.7668 9.65792 24.5455H3.2761ZM18.2761 27.2727C14.5125 27.2727 11.4579 24.2182 11.4579 20.4545C11.4579 16.6909 14.5125 13.6364 18.2761 13.6364C22.0397 13.6364 25.0943 16.6909 25.0943 20.4545C25.0943 24.2182 22.0397 27.2727 18.2761 27.2727ZM18.9579 20.7955L22.8579 23.1L21.8352 24.7636L16.9125 21.8182V15H18.9579V20.7955Z",
                          fill: "#000",
                          "fill-opacity": "0.5",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isUserRegistered
            ? _c(
                "a",
                {
                  staticClass:
                    "bg-white pr-3 pl-3 dropdown-toggle d-flex flex-column h-100 align-items-center justify-content-center fg-normal fg-main-hover fg-main-dropdown-show position-relative font-weight-bold",
                  attrs: {
                    href: "#",
                    role: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "28",
                        height: "30",
                        viewBox: "0 0 28 30",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M25.0943 13.7864V5.45455C25.0943 4.73123 24.8069 4.03754 24.2955 3.52607C23.784 3.01461 23.0903 2.72727 22.367 2.72727H16.667C16.0943 1.14545 14.5943 0 12.8216 0C11.0488 0 9.54882 1.14545 8.9761 2.72727H3.2761C1.7761 2.72727 0.548828 3.95455 0.548828 5.45455V24.5455C0.548828 25.2688 0.836165 25.9625 1.34763 26.4739C1.85909 26.9854 2.55278 27.2727 3.2761 27.2727H11.6079C13.3261 28.9636 15.6715 30 18.2761 30C23.5534 30 27.8215 25.7318 27.8215 20.4545C27.8215 17.85 26.7852 15.5045 25.0943 13.7864ZM12.8216 2.72727C13.5715 2.72727 14.1852 3.34091 14.1852 4.09091C14.1852 4.84091 13.5715 5.45455 12.8216 5.45455C12.0716 5.45455 11.4579 4.84091 11.4579 4.09091C11.4579 3.34091 12.0716 2.72727 12.8216 2.72727ZM3.2761 24.5455V5.45455H6.00337V8.18182H19.6397V5.45455H22.367V11.8364C20.5883 10.9913 18.5916 10.7174 16.6511 11.0524C14.7105 11.3873 12.9212 12.3147 11.5287 13.7072C10.1362 15.0996 9.20888 16.889 8.87392 18.8295C8.53896 20.7701 8.81282 22.7668 9.65792 24.5455H3.2761ZM18.2761 27.2727C14.5125 27.2727 11.4579 24.2182 11.4579 20.4545C11.4579 16.6909 14.5125 13.6364 18.2761 13.6364C22.0397 13.6364 25.0943 16.6909 25.0943 20.4545C25.0943 24.2182 22.0397 27.2727 18.2761 27.2727ZM18.9579 20.7955L22.8579 23.1L21.8352 24.7636L16.9125 21.8182V15H18.9579V20.7955Z",
                          fill: "currentColor",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isUserRegistered
            ? _c(
                "div",
                {
                  staticClass:
                    "main-language-dropdown dropdown-menu dropdown-menu-right dropdown-menu-hover w-100 bg-white p-3 border",
                  attrs: { id: "recent-tasks-nav-drop-down" },
                },
                [
                  _c("div", [
                    _c("div", [
                      _c("p", [
                        _vm._v(_vm._s(_vm._f("trans")("Recent Tasks"))),
                      ]),
                      _vm._v(" "),
                      _vm.tasks.length > 0
                        ? _c(
                            "div",
                            _vm._l(this.tasks, function (task, index) {
                              return index <= 4
                                ? _c(
                                    "a",
                                    {
                                      key: index,
                                      staticClass:
                                        "px-2 br-4 d-flex justify-content-between align-items-center single-task-container",
                                      attrs: { href: _vm.getJobUrl(task.id) },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleReload(task.id)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 14 14",
                                                fill: "none",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M6.66667 12.3333C8.08115 12.3333 9.43771 11.7713 10.4379 10.7712C11.4381 9.77096 12 8.41441 12 6.99992C12 5.58543 11.4381 4.22888 10.4379 3.22868C9.43771 2.22849 8.08115 1.66659 6.66667 1.66659C5.25218 1.66659 3.89562 2.22849 2.89543 3.22868C1.89524 4.22888 1.33333 5.58543 1.33333 6.99992C1.33333 8.41441 1.89524 9.77096 2.89543 10.7712C3.89562 11.7713 5.25218 12.3333 6.66667 12.3333ZM6.66667 0.333252C7.54215 0.333252 8.40905 0.50569 9.21789 0.840722C10.0267 1.17575 10.7617 1.66682 11.3807 2.28587C11.9998 2.90493 12.4908 3.63986 12.8259 4.4487C13.1609 5.25753 13.3333 6.12444 13.3333 6.99992C13.3333 8.76803 12.631 10.4637 11.3807 11.714C10.1305 12.9642 8.43478 13.6666 6.66667 13.6666C2.98 13.6666 0 10.6666 0 6.99992C0 5.23181 0.702379 3.53612 1.95262 2.28587C3.20286 1.03563 4.89856 0.333252 6.66667 0.333252ZM7 3.66659V7.16659L10 8.94659L9.5 9.76659L6 7.66659V3.66659H7Z",
                                                  fill: "black",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "mr-2 m-l-5" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("formatTime")(
                                                    task.created_at,
                                                    _vm.userLocale
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          task.operation_icon.includes("<")
                                            ? _c("span", {
                                                class:
                                                  "mr-1 icon-30 d-inline-flex align-items-center justify-content-center rounded fg-white p-2 bg-main-" +
                                                  task.operation_color,
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    task.operation_icon
                                                  ),
                                                },
                                              })
                                            : _c("i", {
                                                class:
                                                  "icon-30 d-inline-flex flex-shrink-0 align-items-center justify-content-center mr-1 rounded fg-white far " +
                                                  task.operation_icon +
                                                  " bg-main-" +
                                                  task.operation_color,
                                              }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "m-r-11" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.translateTaskName(
                                                    task.readable_operation
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      task?.status?.code === "completed"
                                        ? _c("i", {
                                            staticClass: "far fa-check",
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task?.status?.code === "processing"
                                        ? _c("i", {
                                            staticClass:
                                              "fa fa-spin btn-loading-animation lh-small",
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task?.status?.code === "failed"
                                        ? _c("i", {
                                            staticClass: "fa fa-times",
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e()
                            }),
                            0
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "alert-info px-3 br-4 d-flex align-items-center no-task-container",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("trans")("No Recent Task"))
                                ),
                              ]),
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn w-100 mt-4 all-tasks-btn text-white",
                          attrs: { href: _vm.linkRecentTasks },
                        },
                        [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm._f("trans")("All Tasks"))),
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "fa fa-arrow-right lh-inherit ml-1 py-1",
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }